export default "__VITE_PUBLIC_ASSET__182dca39__"